<template>
  <div>
    <el-row>
      <el-col>
        <rabbey-toolbox>
          <div class="box mr-5">
            <years-component ref="yearC" @change="handler_year" v-model="year">
            </years-component>
            <!-- <years-component :initial="year"></years-component>   *:filterables="true" @filter-search="search = $event"* -->
          </div>

          <el-col :span="6">
            <EmployeeSelector
              :placeholder="'Colaborador'"
              @selection-change="updateSelectedEmployee"
              @list-employee="employeList = $event"
            />
          </el-col>

          <el-col :span="6">
            <DirectionSelector @selection-change="handleChangeDirection" />
          </el-col>
        </rabbey-toolbox>
      </el-col>
    </el-row>

    <el-row>
      <el-col>
        <el-card :body-style="{ padding: '1px' }" shadow="always">
          <RabbeyTable3
            :border="true"
            :stripe="true"
            ref="table"
            v-loading="loading"
            :data="personsData"
            :columns="columnsPersons"
            :height="650"
            fit
          >
          </RabbeyTable3>
        </el-card>
      </el-col>
    </el-row>

    <div id="detail">
      <el-drawer
        title="Tareas del mes"
        :visible.sync="drawer"
        :before-close="handleClose"
        size="70%"
      >
        <el-container>
          <el-main>
            <el-row>
              <el-col :span="8" :xs="8" :sm="24" :md="24" :lg="8">
                <table style="font-size: 25px" id="table-card">
                  <tr style="font-size: 25px">
                    <td>Responsable:</td>
                    <td>
                      <img :src="image ? image : perfilImage" alt="logo_foto" />
                      <strong> {{ Responsable }}</strong>
                    </td>
                  </tr>
                </table>
              </el-col>

              <el-col :span="8" :xs="8" :sm="24" :md="24" :lg="8">
                <table style="font-size: 25px" id="table-card">
                  <tr>
                    <td>
                      <label>Mes:</label>
                      <strong> {{ month }}</strong>
                    </td>
                  </tr>
                </table>
              </el-col>
              <el-col :span="8" :xs="8" :sm="24" :md="24" :lg="8">
                <el-row style="padding: 5px">
                  <table style="font-size: 25px" id="table-card">
                    <tr style="font-size: 20px">
                      <td>Efectividad:</td>
                      <td>
                        <!-- <el-tag :type="GetTagType" style="font-size: 25px">
                          {{ Efective }}
                        </el-tag> -->

                        <el-tag
                          style="font-size: 25px"
                          type="success"
                          v-if="Efective >= 90"
                          >{{ `${Efective}` + `.00` }} %</el-tag
                        >

                        <el-tag
                          style="font-size: 25px"
                          type="danger"
                          v-if="Efective < 71"
                          >{{ `${Efective}` + `.00` }} %</el-tag
                        >

                        <el-tag
                          style="font-size: 25px"
                          type="default"
                          v-if="Efective >= 71 && Efective <= 89"
                          >{{ `${Efective}` + `.00` }} %</el-tag
                        >
                      </td>

                      <p>letra</p>
                    </tr>
                    <tr style="font-size: 20px">
                      <td>Cerrdad a tiempo:</td>
                      <td>
                        <strong> {{ onTime }}</strong>
                      </td>
                    </tr>
                    <tr style="font-size: 20px">
                      <td>Cerrada Tarde:</td>
                      <td>
                        <strong>{{ onDues }}</strong>
                      </td>
                    </tr>
                    <tr style="font-size: 20px">
                      <td>Retrasada:</td>
                      <td>
                        <strong>{{ onRetrass }}</strong>
                      </td>
                    </tr>
                    <tr style="font-size: 20px">
                      <td>Pendiente:</td>
                      <td>
                        <strong> {{ onPedding }}</strong>
                      </td>
                    </tr>
                    <tr style="font-size: 20px">
                      <td>Total:</td>
                      <td>
                        <strong> {{ tasks.length }}</strong>
                      </td>
                    </tr>
                  </table>
                </el-row>
              </el-col>
            </el-row>
            <rabbey-toolbox
              filterables
              @filter-search="detailSearch = $event"
            />

            <el-row>
              <el-col>
                <RabbeyTable3
                  :search="detailSearch"
                  :data="tasks"
                  v-loading="loadingTask"
                  :columns="TaskColumns"
                  :height="600"
                />
              </el-col>
            </el-row>
          </el-main>
        </el-container>
      </el-drawer>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import RabbeyTable3 from "@/components/RabbeyTable3.vue";
import YearsComponent from "../../../../components/Global_System/YearsComponent.vue";
import { PersonColumns, TaskColumns } from "./DashBoardColumns";
import EmployeeSelector from "@/components/Company/EmployeeSelector.vue";
import DirectionSelector from "@/components/Company/DirectionSelector.vue";
// import HyperLinkSeller from "@/components/functionals/HyperLinkSeller.vue";
// import Hypper from "@/components/functionals/HyperLinkDashboard.vue";
export default {
  name: "DashBoardCmi",
  components: {
    YearsComponent,
    DirectionSelector,
    EmployeeSelector,
    RabbeyTable3
  },
  data() {
    return {
      //Se introdujo la propiedad image como nulo para el icono de los empleados de cada tarea asignada

      image: null,
      detailSearch: "",
      search: "",
      Responsable: "",
      EmployeeId: 0,
      month: "",
      TotalCumplida: "",
      TotalFallida: "",
      Total: "",
      percent: 100,

      directionId: 0,
      year: new Date().getFullYear(),
      loading: true,
      loadingTask: true,
      columnsPerson: [],
      data: [],
      tasks: [],
      drawer: false,
      cls: PersonColumns,
      TaskColumns
    };
  },
  methods: {
    showmodal(column) {
      this.image = null;
      this.month = column.column;

      this.Responsable = column.row.PersonName;
      this.loadingTask = true;
      this.$http
        .get("/api/CMI/Task/GetCustomTaks", {
          params: {
            employeeid: column.row.Employeeid,
            month: column.mes,
            year: this.year,
            companyID: this.currentCompany
          }
        })
        .then(({ data }) => {
          //le agino el valor desde la data a la imagen
          this.loadingTask = false;
          this.tasks = data;
          this.image = data[0].UserUrlImage;
        });
      this.drawer = true;
    },
    GetTagType() {
      if (this.percent.replace("%", "") <= 70) {
        return "danger";
      } else if (this.percent.replace("%", "") == 100) {
        return "danger";
      } else if (
        this.percent.replace("%", "") >= 71 &&
        this.percent.replace("%", "") <= 89
      ) {
        return "warning";
      }
      return "warning";
    },
    handleClose() {
      this.drawer = false;
    },
    getData() {
      this.cure;
      this.loading = true;
      let params = {
        year: this.year,
        CompanySeleted: this.currentCompany,
        responsableDirec: this.directionId == 0 ? null : this.directionId,
        responsableEmpl: this.EmployeeId == 0 ? null : this.EmployeeId
      };
      this.$http
        .get("/api/CMI/Objetives/Dashboard", { params })
        .then(({ data }) => {
          //cuando se carga la data la imagen pasa a ser null para limpiar la imagen cada ves que carge una nueva

          this.data = data;
          this.image = false;
          this.loading = false;
        })
        .catch(() => {})
        .finally(() => (this.loading = false));
    },
    handleChangeDirection(directionId) {
      this.directionId = directionId;
      this.getData();
    },
    updateSelectedEmployee(employee) {
      this.EmployeeId = employee;
      this.getData();
    },
    handler_year(_year) {
      this.year = _year;
      this.getData();
    }
  },
  computed: {
    //utilice el mapState para el icono por default de la imagen de los empleados

    ...mapState({
      user: (state) => state.user.user,
      perfilImage: (state) => state.user.imageUrl
    }),

    Efective() {
      let ontime = this.tasks.filter(
        (c) => c.Status !== "Abierta Retrasada" && c.Status !== "Pendiente"
      ).length;
      return ((ontime / this.tasks.length) * 100).toFixed(0) + "%";
    },
    onTime() {
      return this.tasks.filter((c) => c.Status === "Cerrada a Tiempo").length;
    },
    onRetrass() {
      return this.tasks.filter((c) => c.Status === "Abierta Retrasada").length;
    },
    onDues() {
      return this.tasks.filter((c) => c.Status === "Cerrada Retrasada").length;
    },
    onPedding() {
      return this.tasks.filter((c) => c.Status === "Pendiente").length;
    },
    personsData() {
      if (this.data == null) {
        return [];
      }
      return this.data.PersonsProductivites;
    },

    columnsPersons() {
      let columns = this.cls.map((column) => {
        if (column["cellAtrrs"] !== undefined) {
          column["cellAtrrs"] = {
            ...column["cellAtrrs"],
            OpenSelection: this.showmodal
          };

          return {
            ...column
            // formatter: HyperLinkSeller
            //formatter: Hypper
          };
        }

        return column;
      });

      return columns;
    }
  },
  mounted() {
    this.$refs.yearC.Year = this.year;

    this.getData();
  }
};
</script>

<style scoped>
img {
  width: 10%;
  height: 4%;
  border-radius: 50%;
}
</style>
